'use strict';

export default class AdminController {
  menu = [
      {title: 'Home', state: 'admin.home'},
      {title: 'Applications', state: 'admin.apps'},
      {title: 'New', state: 'admin.new'},
      {title: 'Report', state: 'admin.report'},
      {title: 'Stickers', state: 'admin.stickers'},
      {title: 'Users', state: 'admin.users'},
      {title: 'Settings', state: 'admin.settings'}
  ];


  /*@ngInject*/
  constructor(User, $http, stats) {
    // Use the User $resource to fetch all users
    this.users = User.query();
    this.stats = stats;    // Create array of years for car data
  }

  delete(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js